import { Component, Inject, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-input-value-dialog',
  imports: [
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
  ],
  templateUrl: './input-value-dialog.component.html',
  styleUrl: './input-value-dialog.component.scss',
})
export class InputValueDialogComponent {
  private dialogRef = inject(MatDialogRef<InputValueDialogComponent>);
  private fb = inject(FormBuilder);
  title: string = inject(MAT_DIALOG_DATA).title || 'Input Value';

  form = this.fb.group({
    value: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]], // Prevents whitespace-only strings
  });

  submit(): void {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value.value?.trim());
    }
  }
}
